// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nspan[data-v-2daee43b]{\n    display: inline-block;\n    vertical-align: middle;\n    height: 14px;\n    width: 14px;\n    background: transparent center center 100%;\n}\n", ""]);
// Exports
module.exports = exports;
